/**
 * Web App Telemetry Client
 *
 * Initializes TelemetrySdk for the web application.
 * Auto-configures from environment and auth store.
 */

import {
  TelemetrySdk,
  destroyTelemetry,
  getOrCreateDeviceId,
  getTelemetry,
  initTelemetry,
} from "@medicorepay/shared/lib/telemetry-sdk";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5001";

/**
 * Initialize telemetry with user context.
 * Call after successful login.
 */
export function startTelemetry(user: {
  id: string;
  tenantId: string;
  storeId?: string;
}): TelemetrySdk | null {
  return initTelemetry({
    apiBaseUrl: API_URL,
    tenantId: user.tenantId,
    userId: user.id,
    getAuthToken: () => localStorage.getItem("accessToken"),
    storeId: user.storeId,
    deviceId: getOrCreateDeviceId("web"),
    platform: "web",
    appVersion: import.meta.env.VITE_APP_VERSION || "1.0.0",
    batchSize: 20,
    flushIntervalMs: 30_000,
    heartbeatIntervalMs: 60_000,
    debug: import.meta.env.DEV,
  });
}

/**
 * Stop and clean up telemetry. Call on logout.
 */
export async function stopTelemetry(): Promise<void> {
  await destroyTelemetry();
}

/**
 * Get the current telemetry instance for manual tracking.
 */
export { getTelemetry };
